import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-counter-employee-sale-for-date',
  templateUrl: './counter-employee-sale-for-date.component.html',
  styleUrls: ['./counter-employee-sale-for-date.component.scss']
})
export class CounterEmployeeSaleForDateComponent implements OnInit {

  selected_date: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    let data_dict = {
      'selected_date': this.selected_date,
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveCounterEmployeeSaleForDate(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  changeEvent() {
    this.document_file = null;
  }

  ngOnInit() {
  }

}
